<template>
    <div id="banner-02">
        <article class="banner">
            <!-- <div class="text">{{$t('home2021.banners.footer.be_part')}}</div> -->
            <!-- <div class="banner-logo-webstars"></div> -->
            <div class="btn-action">
                <a
                    v-if="webstarsPanelUrl"
                    class="item"
                    :href="webstarsPanelUrl"
                >
                    {{$t('home2021.banners.footer.more_info')}}
                </a>
            </div>
        </article>
    </div>
</template>
<script>
export default {
    name: 'HomeBannerFooter',
    data(){
        return {
            webstarsPanelUrl: process.env.VUE_APP_WEBSTARS_PANEL_URL.replace(/\/+$/, "") + '/login'
        }
    },
}
</script>
<style scoped lang="scss">
@import '../../styles/variables';
@import '../../styles/themes/divas';
@import '../../styles/themes/chads';

section {
    text-align: left;
}

#banner-02{
    .banner{
        height: 330px;
        // background-image: url(/img/2021/banner-04.jpg);
        background-image: var(--img-banners-footer);
        background-position: center;
        background-repeat: no-repeat;
        position: relative;
        overflow: hidden;
        transition: filter 0.5s ease;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-transform: uppercase;
        &.loading {
            filter: blur(20px);
            background-color: var(--pallete_secondary_color);
        }
        @media(max-width: 960px){
            height: 250px;
            background-size: auto 250px;
        }

        .text{
            font-family: "Helvetica Narrow", Arial, Helvetica, sans-serif,sans-serif;
            transform: scale(1.2,  1.7);
            font-size: 2em;
            color: #ffffff;
            @media(max-width: 960px){
                transform: scale(1,  1);
            }
        }

        .banner-logo-webstars{
            width: 286px;
            height: 44px;
            background-position: center;
            background-repeat: no-repeat;
            background-image: var(--img-logo);
            background-size: contain;
            margin-top: 20px;
            margin-bottom: 20px;
            @media(max-width: 960px){
                margin-top: 5px;
                margin-bottom: 5px;
            }
        }

        .btn-action{
            // width: 156px;
            padding-inline: 1em;
            margin-top: 5em;
            line-height: 2.5;
            text-align: center;
            font-weight: bold;
            font-size: 1.2em;
            border-radius: 10px;
            transition: 200ms;
            
            color: #ffffff;
            // background-image: url("/img/backgrounds/button-webstar.png");
            background-image: linear-gradient(to left, var(--pallete_degrade_start_color), var(--pallete_degrade_finish_color));

            &:hover{
                // background-image: linear-gradient(to left, var(--pallete_degrade_start_color-lighten-10), var(--pallete_degrade_finish_color-lighten-10));
                filter: brightness(1.1);
            }

            a{
                display: block;
                width: 100%;
                height: 100%;
            }
            @media(max-width: 960px){
            }
        }
    }
}

</style>
